import Immutable, { Record, OrderedMap, List } from 'immutable';

import SkillResult from './SkillResults';
import TotalScore from './TotalScore';

const StudentProgressTestResultsRecord = Record({
  studentId: undefined,
  canBeOverwrite: undefined,
  isPTSessionMember: undefined,
  skillResults: new OrderedMap(),  // key: skillId
  totalScore: TotalScore.create(),
  previousTotalScore: TotalScore.create(),
});

class StudentProgressTestResults extends StudentProgressTestResultsRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, `${val}`];
    case 'canBeOverwrite':
      return [key, Boolean(val)];
    case 'isPTSessionMember':
      return [key, Boolean(val)];
    case 'totalScore':
    case 'previousTotalScore':
      return [key, TotalScore.create(val)];
    case 'skillResults':
      // if we've constructed this using an existing OrderedMap, keep it
      if (OrderedMap.isOrderedMap(val)) return [key, val];
      return [key, new OrderedMap(val.map((item) => {
        const skillResult = SkillResult.create(item);
        return [skillResult.skillId, skillResult];
      }))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

StudentProgressTestResults.create = (data) =>
  new StudentProgressTestResults(data).mapEntries(reviver);

StudentProgressTestResults.serialize = (studentProgressTestResults) =>
  studentProgressTestResults.map((studentProgressTestResult) => {
    const serializedModel = studentProgressTestResult.toObject();
    serializedModel.skillResults =
      studentProgressTestResult.skillResults.toList();
    return serializedModel;
  }).toList();

StudentProgressTestResults.isSerialized = (studentProgressTestResults) =>
  studentProgressTestResults.every((studentProgressTestResult) =>
    List.isList(studentProgressTestResult.skillResults));

export default StudentProgressTestResults;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/model.js